import { useRouter } from "@uirouter/react";
import { noop } from "lodash";
import {
  ComponentProps,
  FunctionComponent,
  useCallback,
  useContext,
} from "react";
import styled from "styled-components";
import { PrimaryButton } from "../../../components/button";
import { useAppLoader } from "../../../components/loader/app-loader-hook";
import { GlobalOverlayContext } from "../../../components/overlay/context";
import { ParticipationsService } from "../../../store/participations/service";
import { ParticipationsRoutes } from "../routes";

const CTA = styled(PrimaryButton)`
  margin-top: 2em;
`;

export const RemoveParticipationModal: FunctionComponent<{
  id: string;
}> = ({ id }) => {
  const loader = useAppLoader();
  const router = useRouter();
  const { setOverlay } = useContext(GlobalOverlayContext);

  const onRemove = useCallback(
    () =>
      loader(
        ParticipationsService.removeParticipation(id)

          .then(() => router.stateService.go(ParticipationsRoutes.names.all))
          .then(() => setOverlay({ children: undefined }))
          .catch(noop)
      ),
    [id]
  );

  return (
    <>
      <p>Are you sure you want to delete participation?</p>
      <CTA onClick={onRemove}>Confirm</CTA>
    </>
  );
};

export type RemoveParticipationModalProps = ComponentProps<
  typeof RemoveParticipationModal
>;
